import { Fragment, useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { styles } from "."
import { Stack, Button } from "@mui/material"
import { Table, TableBody, TableRow, TableCell } from "@mui/material"
import api from "../../../../../../api/axios"
import { UserContext } from "../../../../../../context/UserContext"

export default function Component(props) {
    const navigate = useNavigate()
    const { user, refreshUserProfile, setRefreshUserProfile, getEmployer, getEmployerPlan, createPermissibleClass } = useContext(UserContext);
    const { onboarding, mode, step, employerPlanId, displayClassCount, onStartNavigating, onCancelNavigating } = props
    const employer = getEmployer();
    const employerId = employer?.id
    const employerPlan = getEmployerPlan(employerPlanId)
    const employeeClasses = employerPlan?.permissibleClasses || []
    const planType = employerPlan?.type || ""
    
    // Use frozen class count if provided (during navigation), otherwise use actual
    const classesToDisplay = displayClassCount !== undefined ? 
        employeeClasses.slice(0, displayClassCount) : 
        employeeClasses
    
    const params = `planId=${employerPlan?.id}&planType=${planType}&mode=${mode}&planStep=${step}&onboarding=${onboarding}&step=${step}`

    async function handleAdd() {
        try {
            // Set navigating flag to freeze the UI
            if (onStartNavigating) {
                onStartNavigating()
            }
            
            const permissibleClass = await createPermissibleClass(employerPlan);
            setRefreshUserProfile();
            
            // Refresh and then navigate
            await refreshUserProfile();
            
            const path = `/employer-flow/plans/?onboarding=${onboarding}&step=${step + 1}&classId=${permissibleClass?.id}`
            navigate(path, { replace: true })
        } catch (error) {
            console.error(error)
            // Cancel navigating on error
            if (onCancelNavigating) {
                onCancelNavigating()
            }
        }
    }

    async function handleUpdate(employeeClass) {
        try {
            // Set navigating flag
            if (onStartNavigating) {
                onStartNavigating()
            }
            
            setRefreshUserProfile();
            const path = `/employer-flow/plans/?onboarding=${onboarding}&step=${step + 1}&classId=${employeeClass?.id}`
            navigate(path);
        } catch (error) {
            console.error(error)
            // Cancel navigating on error
            if (onCancelNavigating) {
                onCancelNavigating()
            }
        }
    }

    async function handleDelete(employeeClass) {
        try {
            if (window.confirm("Do you really want to delete the employee class?")) {
                // note: check for success. if emp assigned, will fail
                const url = `employer/${employerId}/plan/${employerPlan?.id}/class/${employeeClass?.id}`
                await api.delete(url)
                setRefreshUserProfile();
                await refreshUserProfile();
                const path = `/employer-flow/plans/?onboarding=${onboarding}&step=${step}&planId=${employerPlan?.id}`
                navigate(path);
            }
        } catch (error) {
            console.error(error)
        }
    }

    async function getData() {
        try {
            await refreshUserProfile();
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        if (user) {
            getData()
        }
    }, [user])

    return (
        <Fragment>
            <ThemeProvider theme={createTheme({ components: styles.table })}>
                <Button sx={styles.addButton} type="button" onClick={() => handleAdd()}>
                    + Add Class
                </Button>
                {classesToDisplay?.length > 0 && (
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{ width: "80%" }}>Employee Class</TableCell>
                                <TableCell sx={{ width: "20%", textAlign: "center" }}>Actions</TableCell>
                            </TableRow>
                            {classesToDisplay?.map((employeeClass) => {
                                return (
                                    <TableRow key={employeeClass?.id}>
                                        <TableCell sx={{ fontWeight: "400 !important" }}>
                                            {employeeClass?.name} {!employeeClass?.isComplete ? "(Incomplete)" : ""}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            <Stack sx={styles.tableActions}>
                                                <button type="button" onClick={() => handleUpdate(employeeClass)}>Update</button>
                                                <button type="button" onClick={() => handleDelete(employeeClass)}>Delete</button>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                )}
            </ThemeProvider>
        </Fragment>
    )
}